<div class="time-layout">
  <div class="time-container" fxLayout="row" fxLayoutGap=".5rem" fxLayoutAlign="flex-start center">
    <h2 mat-dialog-title class="time-title">Add Clinical Time</h2>
    <!-- With care plan time on there is no split: an edit saves every row to the same entry, where a second
         row would replace the first row's care plan work, and a new entry covers one clinical note. -->
    <button
      *ngIf="!carePlanTimeOn"
      mat-icon-button
      color="accent"
      type="button"
      aria-label="Split time"
      (click)="addTime()"
      matTooltip="Add time"
    >
      <mat-icon>add_circle</mat-icon>
    </button>
  </div>
  <section *ngIf="noteRequired" class="time-note" aria-live="polite">
    <ng-container *ngIf="linkedNote; else noLinkedNote">
      <span class="time-note__label">Clinical note for this time</span>
      <p class="time-note__text">{{ linkedNotePreview }}</p>
    </ng-container>
    <ng-template #noLinkedNote>
      <p class="time-note__text time-note__text--missing">
        Write and save the clinical note first. Saving it opens this form with the note attached.
      </p>
    </ng-template>
  </section>
  <!-- Only the form scrolls: the title and the buttons stay in view, and each row's time sticks to the top
       while its programs scroll under it. -->
  <form [formGroup]="form" fxLayout="column" fxLayoutGap=".5rem" class="time-body">
    <ng-container formArrayName="times">
      <div *ngFor="let timeForm of times.controls; let i = index" [formGroup]="timeForm" class="time-row">
        <div fxLayout="row" fxLayoutGap=".5rem" fxLayoutAlign="center center" class="problem-form time-row-inputs">
          <mat-form-field fxFlex="15">
            <mat-label>Mins</mat-label>
            <input
              class="clinical-time-input clinical-time-input--mins"
              [style.--mins-chars]="minutesLength(timeForm.get('mins'))"
              min="0"
              step="1"
              pattern="\d+"
              matInput
              type="number"
              placeholder="Mins"
              formControlName="mins"
              (input)="trimMinutes(timeForm.get('mins'), $event.target)"
              required
            />
          </mat-form-field>
          <div>:</div>
          <mat-form-field fxFlex="15">
            <mat-label>Secs</mat-label>
            <input
              class="clinical-time-input"
              min="0"
              max="59"
              step="1"
              pattern="\d{1,2}"
              type="number"
              placeholder="Secs"
              matInput
              formControlName="secs"
              (input)="limitSeconds(timeForm.get('secs'), $event.target)"
              required
            />
          </mat-form-field>

          <button
            fxFlex="10"
            mat-icon-button
            color="warn"
            type="button"
            aria-label="Delete time"
            (click)="deleteTime(i)"
          >
            <mat-icon class="delete-btn">delete_forever</mat-icon>
          </button>
        </div>
        <ng-container [formGroup]="timeForm.get('categories')">
          <div class="program-grid" [style.grid-template-rows]="'repeat(' + programRows + ', auto)'">
            <mat-checkbox
              [matTooltipShowDelay]="delay"
              formControlName="{{ program.value }}"
              [matTooltip]="
                timeForm.get('categories').get(program.value)?.disabled
                  ? program.value === 'ccm'
                    ? 'The patient must have at least two diagnoses associated to CCM'
                    : 'This patient doesn’t have any diagnoses associated to ' + program.value.toUpperCase()
                  : program?.description
              "
              *ngFor="let program of programs"
              >{{ program.name }} ({{ program?.value?.toUpperCase() }})
              <span *ngIf="!program.billable_by_time">(Not billable)</span></mat-checkbox
            >
          </div>
          <hr style="width: 100%" />
          <mat-checkbox formControlName="non_billable">Non-Billable Patient Care</mat-checkbox>
        </ng-container>
        <!-- CCM care plan time (BRD-CLIN-2026-008): only on CCM rows of a clinic switched on. -->
        <app-ccm-care-plan-picker
          *ngIf="showsCarePlanPicker(timeForm)"
          formControlName="care_plan_work"
          [plans]="carePlanPlans"
          [status]="carePlanStatus"
          [requirePicks]="requiresCarePlanPicks(timeForm)"
          [rowLabel]="times.length > 1 ? 'Time ' + (i + 1) : ''"
          (retry)="retryCarePlans()"
          [canCreateCarePlan]="canCreateCarePlan"
          (createCarePlan)="goToCarePlans(timeForm)"
        ></app-ccm-care-plan-picker>
      </div>
    </ng-container>
    <hr style="width: 100%" />
    <label id="contact-status-label" class="contact-status-label">Did you interact with the patient? *</label>
    <mat-radio-group
      formControlName="contact_status"
      aria-labelledby="contact-status-label"
      class="contact-status-group"
      fxLayout="column"
      fxLayoutGap=".25rem"
    >
      <mat-radio-button value="spoke">Spoke with the patient (live, two-way)</mat-radio-button>
      <mat-radio-button value="attempted">Attempted only (voicemail, text, email, no answer)</mat-radio-button>
      <mat-radio-button value="none">No contact</mat-radio-button>
    </mat-radio-group>
    <hr style="width: 100%" />
    <mat-checkbox formControlName="exclude">Exclude for concurrent E/M visit</mat-checkbox>
    <mat-checkbox formControlName="require_provider_intervention">Required provider intervention</mat-checkbox>
    <mat-checkbox formControlName="device_troubleshooting">Device troubleshooting</mat-checkbox>
  </form>
  <div fxLayout.xs="row" fxLayoutAlign="end" class="time-buttons" fxLayoutGap=".5rem">
    <app-google-review-buttom></app-google-review-buttom>
    <!-- A form opened for time that waited on its note must be saved, unless saving cannot succeed (see canCancel). -->
    <button *ngIf="canCancel" mat-button (click)="cancel()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      (click)="saveTime()"
      cdkFocusInitial
      [disabled]="form.invalid || loading || missingNote"
    >
      {{ checkingCall ? 'Checking call...' : 'Save' }}
    </button>
    <mat-progress-spinner *ngIf="loading" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
  </div>
</div>
